/* eslint-disable no-console */
import React from 'react';
import { Grid } from '@mui/material';
import FeedCards from '../FeedCards';
import { useParams } from 'react-router-dom';

const DraftFeeds = ({ searchVal }: { searchVal: string }) =>
{
	const type = useParams()?.type ?? 'draft';
	const requestT = { type };

	return (
		<Grid container flexDirection={'column'}>
			<FeedCards requestT={requestT} searchVal={searchVal} />
		</Grid>
	);
};

export default DraftFeeds;